<template lang="pug">
div
  v-expansion-panels(accordion flat tile v-model="expandedPanels" multiple v-if="currentLight" ref="expansionPanelRef")
    v-expansion-panel.mb-5(v-for="(theme, theme_index) in form.RisikoThemen" :key="theme_index")
      v-expansion-panel-header.category-header {{ theme.name }}
      v-expansion-panel-content(eager v-if="expandedPanels.includes(theme_index)")
        v-row.mt-5(style="position: sticky; top: 0; z-index: 98; background: #fff;")
          v-spacer
          v-col.text-center(cols="3")
            h4 Status
          v-col.text-center(cols="3")
            h4 Konzept
        h4.my-3 Risikothemen
        v-expansion-panels.flat-panels.theme-item-panel(accordion flat tile multiple color="white")
          v-expansion-panel.mb-5(v-for="(theme_item, theme_item_index) in theme.data" :disabled="!theme_item.active" :key="theme_item_index")
            v-row.align-center(style="position: relative")
              v-col.pr-0(cols="3" @click="setRowVisibility(theme_item, [{ path: `RisikoThemen.${theme_index}.data.${theme_item_index}.active`, value: true }])"): v-expansion-panel-header.flat-panel-header
                v-checkbox.mt-0(
                    label=''
                    dense
                    hide-details
                    v-model="theme_item.active"
                    @click="(e) => e.stopPropagation()"
                    @change="(value) => changeForm([{ path: `RisikoThemen.${theme_index}.data.${theme_item_index}.active`, value }])")
              label(style="position: absolute; bottom: 36px; right:auto; left:60px") {{theme_item.name}}
              v-col(cols="3"): v-text-field(
                outlined
                label="Angezeigter Name"
                v-model="theme_item.display_name"
                dense
                @change="(value) => changeForm([{ path: `RisikoThemen.${theme_index}.data.${theme_item_index}.display_name`, value: theme_item.display_name }])"
              )
            v-expansion-panel-content(eager v-if="expandedThemeItems(theme).includes(theme_item_index)")
              h4.mt-3 {{ theme_item.meta_name }}
              v-row.align-center
                v-col(cols="3") Qualität der Absicherung
                v-spacer
                v-col(cols="3"): v-select(
                  v-model="theme_item.cur_rating"
                  outlined
                  :items="ratings"
                  @change="(value) => changeForm([{ path: `RisikoThemen.${theme_index}.data.${theme_item_index}.cur_rating`, value }])"
                )
                v-col(cols="3"): v-select(
                  v-model="theme_item.new_rating"
                  outlined
                  :items="ratings"
                  @change="(value) => changeForm([{ path: `RisikoThemen.${theme_index}.data.${theme_item_index}.new_rating`, value }])"
                )
              form-generate(
                :themeName="theme_item.name"
                :fields="theme_item.MetaDaten"
                :frequency="paymentFrequency"
                isMetaData
                @changeVal="(values) => dataChange(`RisikoThemen.${theme_index}.data.${theme_item_index}.MetaDaten.`, values)"
              )
              v-row.mt-5
                v-col(cols="3")
                  h4 Leistungsumfang
                v-spacer
                v-col.text-center(cols="3")
                  h4 Status
                v-col.text-center(cols="3")
                  h4 Konzept
              form-generate(
                :themeName="theme_item.name"
                :fields="theme_item.data"
                :isMetaData="false"
                :frequency="paymentFrequency"
                @setThemeActive="(values) => setThemeActive(theme_index, theme_item_index, values)"
                @changeVal="(values) => dataChange(`RisikoThemen.${theme_index}.data.${theme_item_index}.data.`, values)"
              )
              v-row.mt-5
                v-col(cols="3")
                  h4 Notizen
                v-col(cols="9")
                  v-textarea.pt-0(
                    v-model="theme_item.notes"
                    outlined
                    hide-details
                    @change="changeForm([{ path: `RisikoThemen.${theme_index}.data.${theme_item_index}.notes`, value: theme_item.notes }])"
                  )
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import urls from '../../../../router/urls'

@Component({
  components: {
    FormGenerate: () => import('./FormGenerate.vue'),
  }
})

export default class Analysis extends Vue {
  @Prop({ type: Object | null, default: null }) currentLight
  @Prop({ type: [ Number, String ], default: 0 }) lightId

  form = {}
  ratings = ['Gut abgesichert', 'Teilweise abgesichert', 'Unzureichend abgesichert', 'Nicht abgesichert']
  expandedPanels = []
  expandedSubPanels = []
  paymentFrequency = null

  mounted () {
    this.$axios
      .get(urls.ConsultationLight(), { id: this.lightId })
      .then(res => {
        this.form = res.data?.data
        this.paymentFrequency = res.data?.payment_frequency
      })
  }

  expandedThemeItems (theme) {
    if (theme && theme.data) {
      return theme.data.filter(item => item.active === true).map((item, index) => theme.data.findIndex(i => i === item))
    } else {
      return []
    }
  }

  dataChange (path, values) {
    const handledValues = values.map(item => {
      return {
        path: path + item.path,
        value: item.value
      }
    })

    this.changeForm(handledValues)
  }

  setThemeActive (themeIndex, themeItemIndex, values) {
    const handledValues = [
      {
        path: `RisikoThemen.${ themeIndex }.data.${ themeItemIndex }.active`,
        value: true
      }
    ]

    values.forEach(item => {
      handledValues.push({
        path: `RisikoThemen.${ themeIndex }.data.${ themeItemIndex }.data.${ item.path }`,
        value: item.value
      })
    })

    this.changeForm(handledValues)
  }

  setRowVisibility (themeItem, value) {
    if (!themeItem.active) {
      this.changeForm(value)
    }
  }

  changeForm (values) {
    const params = {
      document_id: parseInt(this.lightId),
      values
    }

    this.$axios
      .post(urls.ConsultationLight(), params)
      .then((res) => {
        this.form = res.data.data
      })
      .catch((err) => {
        this.$toast.error(err.message, 'Fehler')
      })
  }
}
</script>

<style scoped lang="scss">
::v-deep .flat-panels .v-expansion-panel-header__icon{
  top: 10px !important;
}
</style>
